import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";

function PracticeCompleteCard({ cards, practiceStats }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 3, md: 5 },
        borderRadius: "22px",
        border: "1px solid #d7eaf5",
        bgcolor: "#fffefd",
        textAlign: "center",
        boxShadow: "0 26px 58px -38px rgba(19, 43, 63, 0.56)",
      }}
    >
      <Typography sx={{ color: "var(--toeic-ink-soft)", fontSize: 13, fontWeight: 800, textTransform: "uppercase", mb: 1 }}>
        Practice complete
      </Typography>
      <Typography sx={{ color: "var(--toeic-ink-deep)", fontSize: { xs: 30, md: 44 }, fontWeight: 800, lineHeight: 1.08 }}>
        You finished {cards.length} {cards.length === 1 ? "card" : "cards"}
      </Typography>
      <Grid container spacing={1.25} sx={{ mt: 3 }}>
        {[
          ["Known", practiceStats.known],
          ["Review", practiceStats.review],
          ["Typed", practiceStats.typed],
          ["Typos", practiceStats.typos],
        ].map(([label, value]) => (
          <Grid item xs={6} sm={3} key={label}>
            <Box sx={{ p: 1.5, borderRadius: "16px", bgcolor: "#f4fbff", border: "1px solid #d7eaf5" }}>
              <Typography sx={{ color: "var(--toeic-ink-deep)", fontSize: 24, fontWeight: 800 }}>
                {value}
              </Typography>
              <Typography sx={{ color: "var(--toeic-ink-soft)", fontSize: 12.5, fontWeight: 600 }}>
                {label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}

export default PracticeCompleteCard;